import React, { useState } from 'react';
import HTMLViewer from '../components/HTMLViewer';
import './Page.css';

/**
 * Page to view original backup HTML files
 * Use this to see the original content and extract it manually
 */
const ViewBackup = () => {
  const [selectedFile, setSelectedFile] = useState('blog.html');

  const files = [
    { value: 'blog.html', label: 'Blog' },
    { value: 'faq.html', label: 'FAQ' },
    { value: 'privacy.html', label: 'Privacy Policy' },
    { value: 'termsofuse.html', label: 'Terms of Use' },
    { value: 'contact.html', label: 'Contact' },
  ];

  return (
    <div className="page">
      <section className="page-header">
        <div className="container">
          <h1>View Backup Files</h1>
          <p className="page-subtitle">Select a file to view the original content</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="file-select" style={{ marginRight: '10px', fontWeight: '600' }}>
              Select File:
            </label>
            <select
              id="file-select"
              value={selectedFile}
              onChange={(e) => setSelectedFile(e.target.value)}
              style={{
                padding: '10px 15px',
                fontSize: '16px',
                borderRadius: '8px',
                border: '2px solid #e0e0e0',
                cursor: 'pointer'
              }}
            >
              {files.map(file => (
                <option key={file.value} value={file.value}>
                  {file.label}
                </option>
              ))}
            </select>
          </div>

          <div style={{ 
            border: '1px solid #e0e0e0', 
            borderRadius: '8px', 
            overflow: 'hidden',
            minHeight: '600px'
          }}>
            <HTMLViewer filename={selectedFile} title={files.find(f => f.value === selectedFile)?.label} />
          </div>

          <div style={{ 
            marginTop: '30px', 
            padding: '20px', 
            background: '#f8f9fa', 
            borderRadius: '8px' 
          }}>
            <h3>Instructions:</h3>
            <ol style={{ lineHeight: '1.8' }}>
              <li>View the original content in the iframe above</li>
              <li>Copy the text content you want to use</li>
              <li>Update the corresponding React component:
                <ul>
                  <li><strong>Blog:</strong> Update <code>src/pages/Blog.js</code> - replace blog posts with actual content</li>
                  <li><strong>FAQ:</strong> Update <code>src/pages/FAQ.js</code> - replace the <code>faqs</code> array</li>
                  <li><strong>Privacy:</strong> Update <code>src/pages/Privacy.js</code> - replace content sections</li>
                  <li><strong>Terms:</strong> Update <code>src/pages/Terms.js</code> - replace content sections</li>
                  <li><strong>Contact:</strong> Update <code>src/pages/Contact.js</code> - replace contact details</li>
                </ul>
              </li>
            </ol>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ViewBackup;

